import { Injectable } from '@angular/core';
import { StorageService } from './storage-service.service';
import { NativeLayerService } from './native-layer.service';
import { SessionStore } from '@ildes/stores/session.store';
const ELEMENTS_TO_SAVE_IN_PREFERENCES = ['luminaries', 'expansions', 'modernizations', 'assignedMaintenances', 'dailyQuestionaries'];

@Injectable({
  providedIn: 'root'
})
export class UserStorageService extends StorageService{

  constructor(
    native: NativeLayerService
  ) {
    super(native)
  }

  getItem(key: string, meta = false) {
    const userId = SessionStore.getInstance()?.get()?.user?.id;

    key = `${userId || ''}.${key}`;

    return super.getItem(key);
  }

  setItem(originalKey, value) {
    const userId = SessionStore.getInstance()?.get()?.user?.id;
    const key = `${userId || ''}.${originalKey}`;

    const persistent = ELEMENTS_TO_SAVE_IN_PREFERENCES.indexOf(originalKey) >= 0;
    super.setItem(key, value, persistent);
  }

  async initFromPreferences() {
    const elements = ELEMENTS_TO_SAVE_IN_PREFERENCES.map((preferencesKey) => {
        const userId = SessionStore.getInstance()?.get()?.user?.id;
        const key = `${userId || ''}.${preferencesKey}`;

        return key;
    })
    return super.initFromPreferences(elements);
  }
}
